import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { trialsCrudStateConfig } from "../../../consts";

export type { CrudBuilderState as PremiumTrialMeta };

export const trialMetaInitialState = makeCrudBuilderInitialState(
  trialsCrudStateConfig
);
